import Bucket from './Bucket';

export default Bucket;
